export default __webpack_public_path__ + "static/media/00.d66ec26b.jpg";